import React from 'react';
import styles from './LeadText.module.css';
import { LeadTextProps } from './types';

export const LeadText = ({ text }: LeadTextProps) => {
    return (
        <div className={styles.content}>
            <div className={styles.wrapper}>
                <img
                    src={'/foodslaboEf/img/common/lightIcon.svg'}
                    alt={'電球アイコン'}
                />
                <p className={styles.LeadText}>{text}</p>
            </div>
        </div>
    );
};
